import React from 'react';
import { PropTypes as PT } from 'prop-types';
import clsx from 'clsx';
import classes from './NotificationPill.module.scss';

/**
 * Notification Pill component
 */
class NotificationPill extends React.PureComponent {
  render() {
    if ((this.props.inCall && this.props.isMinimized) || !this.props.message) return null;

    const containerClassNames = clsx(classes.notificationContainer, this.props.inCall && classes.inCall);
    return (
      <div className={containerClassNames}>
        <div className={classes.notification}>{this.props.message}</div>
      </div>
    );
  }
}

NotificationPill.propTypes = {
  message: PT.string,
  inCall: PT.bool,
  isMinimized: PT.bool
};

export default NotificationPill;
